import React from 'react';

import HomeDecorator from './HomeDecorator';
import { withCookies } from 'react-cookie';
import GetDemoForm from './GetDemoForm';

class GetDemoView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mktplace_token: null,
    };
  }

  componentDidMount() {
    //get saml token and redirect url
    const { cookies } = this.props;

    let mktplace_token = cookies.get('amz-token') || '';

    this.setState(
      {
        mktplace_token,
      },
      () => {
        if (mktplace_token !== null && mktplace_token !== '') {
          this.props.getMktplaceUser(mktplace_token);
        }
      },
    );
  }

  render() {
    const { awsToken, isLoading } = this.props;
    const { mktplace_token } = this.state;

    return HomeDecorator(
      <div
        style={{
          width: '100vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <GetDemoForm
          mktplace_token={mktplace_token}
          customer_identifier={awsToken.customer_identifier}
          product_code={awsToken.product_code}
        />
      </div>,
      awsToken.tokenError,
      isLoading,
    );
  }
}

export default withCookies(GetDemoView);
